import { Button, CircularProgress } from "@mui/material";
import { Alert } from "react-bootstrap";
import DeleteIcon from "../../Assets/delete.svg";

function DeleteSubCategoryModal(props) {
  const { confirmDelete, setShowDeleteMsg, isLoading, error } = props;

  return (
    <div>
      <>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 100,
          }}
        ></div>
        <Alert
          variant="light"
          // onClose={() => setShowSuccessMessage(false)}
          dismissible={false}
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "22vw",
            height: "auto",
            zIndex: 1000,
          }}
        >
          <Alert.Heading
            style={{
              textAlign: "center",
            }}
          >
            <div className="delete-icon-section">
              <img
                src={DeleteIcon}
                alt="delete"
              />
            </div>
            {/* Confirm Delete */}
          </Alert.Heading>
          <p className="fs-4 fw-semibold text-center text-black">
            Are you sure you ?
          </p>
          <p className="text-center">
            All the documents under this subcategory will automatically be transferred to the "Uncategorized" category.
          </p>
          {error && (
            <Alert variant="danger" className="mt-3">
              {error}
            </Alert>
          )}
          <div
            className="d-flex justify-content-end"
            style={{ display: "grid", gridGap: "10px" }}
          >
            <Button
              style={{ color: "white" }}
              className="btn bg-danger mr-2 w-auto text-capitalize"
              onClick={() => {
                confirmDelete();
              }}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={20} style={{ color: 'white' }} />
              ) : (
                'Delete'
              )}
            </Button>
            <Button
              className="btn bg-info btn-secondary text-white w-auto text-capitalize"
              onClick={() => {
                setShowDeleteMsg(false);
              }}
              disabled={isLoading}
            >
              Cancel
            </Button>
          </div>
        </Alert>
      </>
    </div>
  );
}

export default DeleteSubCategoryModal;
